import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  getPerformance,
  getRankProgression,
  getSameDayLastMonth,
  getTeams,
} from '/redux/action/coach.action';
import {
  getClientMetrics,
  getHomeMetrics,
  getTeamsMetrics,
} from '/redux/action/metric.action';
import {
  competencyById,
  hasEarningsById,
  hasPerformanceById,
  hasSameDayLastMonthById,
  hasTeamsById,
  highestAchievedRankDescriptionById,
  nextRankIdById,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {hasClientMetricsById} from '/redux/selector/metric.clients.selector';
import {hasHomeMetricsById} from '/redux/selector/metric.home.selector';
import {hasTeamsMetricsById} from '/redux/selector/metric.teams.selector';
import {generateCallback} from '/util/component.util';
import {withProps} from '/util/selector.util';

import Dashboard from './Dashboard';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    userId,
    rankId: withCurrentUserCoachId(nextRankIdById),
    currentUserCompetency: withCurrentUserCoachId(competencyById),
    hasTeamsMetricsById: withCurrentUserCoachId(hasTeamsMetricsById),
    hasClientMetricsById: withCurrentUserCoachId(hasClientMetricsById),
    hasHomeMetricsById: withCurrentUserCoachId(hasHomeMetricsById),
    hasTeamsById: withCurrentUserCoachId(hasTeamsById),
    hasPerformance: withCurrentUserCoachId(hasPerformanceById),
    hasSameDayLastMonth: withCurrentUserCoachId(hasSameDayLastMonthById),
    hasEarnings: withCurrentUserCoachId(hasEarningsById),
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highestRankDescription: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
    coachCurrentRank: withProps({coachId: userId})(rankDescriptionById),
  }),
  dispatch => ({
    getTeamsMetrics: generateCallback({
      func: dispatch,
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      params: getTeamsMetrics(),
    }),
    getClientMetrics: generateCallback({
      func: dispatch,
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      params: getClientMetrics(),
    }),
    getHomeMetrics: generateCallback({
      func: dispatch,
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      params: getHomeMetrics(),
    }),
    // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
    getPerformance: ({coachId}: any) => dispatch(getPerformance({coachId})),
    getRankProgression: ({coachId, rankId}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(getRankProgression({coachId, rankId})),
    // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
    getTeams: ({coachId}: any) => dispatch(getTeams({coachId})),
    getSameDayLastMonth: ({coachId}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(getSameDayLastMonth({coachId})),
  }),
  (stateProps, dispatchProps, ownProps) => {
    const {userId: coachId, rankId, hasPerformance, hasEarnings} = stateProps;

    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      hasPerformanceMetrics: hasPerformance && hasEarnings,
      getRankProgression: () =>
        dispatchProps.getRankProgression({
          coachId,
          rankId,
        }),
      getPerformanceMetrics: () =>
        Promise.all([dispatchProps.getPerformance({coachId})]),
      getTeams: () =>
        dispatchProps.getTeams({
          coachId,
        }),
      getSameDayLastMonth: () =>
        Promise.all([
          dispatchProps.getSameDayLastMonth({
            coachId,
          }),
        ]),
    };
  },
)(Dashboard);
